// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.trade-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.trade-shell {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  position: relative;
  width: clamp(900px, 82vw, 1700px);
  height: clamp(560px, 65vh, 1150px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: ink-enter 0.16s ease-out;
}
.trade-shell * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .trade-shell {
    animation: none;
  }
}

.trade-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 18px 24px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.trade-header__brand {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}
.trade-header__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}

.trade-body {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1px 200px 1px 1fr;
  gap: 20px;
  padding: 16px 24px 20px;
  overflow: hidden;
}

.trade-divider {
  align-self: stretch;
  background: rgba(255, 255, 255, 0.12);
}

.trade-heading {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
}

.trade-lock-tag {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  color: #8d8a82;
}
.trade-lock-tag--accent {
  color: var(--gold-light);
}

.trade-pane {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.trade-pane--locked {
  opacity: 0.85;
}

.trade-pane-group {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}
.trade-pane-group .trade-pane {
  flex: 1 1 0;
}

.trade-list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.trade-list::-webkit-scrollbar {
  width: 6px;
}
.trade-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.trade-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 9px 10px 9px 12px;
  font-size: 15px;
  color: #aeaba2;
  background: none;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 2px solid transparent;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.trade-item--clickable {
  cursor: pointer;
}
.trade-item--clickable:hover {
  background: rgba(255, 255, 255, 0.04);
  color: #ebe8e1;
  border-left-color: var(--gold-main);
}
.trade-item__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.trade-item__count {
  flex: none;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
}

.trade-empty {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #8d8a82;
}

.trade-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.trade-choose-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.trade-choose-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.trade-choose-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.trade-choose-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.trade-choose-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.trade-choose-btn:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.trade-choose-btn--ghost {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.2);
}
.trade-choose-btn--ghost:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.trade-choose-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.trade-choose-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.trade-choose-btn:disabled {
  color: #8d8a82;
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.12);
}

.trade-confirm-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 5, 0.72);
  animation: ink-enter 0.16s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .trade-confirm-overlay {
    animation: none;
  }
}

.trade-confirm {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  width: min(460px, 86%);
  padding: 22px 24px;
}
.trade-confirm * {
  box-sizing: border-box;
}
.trade-confirm__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin-bottom: 12px;
}
.trade-confirm__text {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  font-size: 15px;
  color: #ebe8e1;
  margin-bottom: 18px;
}
.trade-confirm__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}
.trade-confirm__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.trade-step-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  width: 36px;
  height: 36px;
  padding: 0;
  font-size: 18px;
}
.trade-step-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.trade-step-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.trade-step-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.trade-step-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

.trade-count-input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: 72px;
  height: 36px;
  text-align: center;
}
.trade-count-input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.trade-count-input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/trade/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AALA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yDDiBU;ACVZ;;AAJA;EDiBE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EC3BA,oBAAA;EACA,kBAAA;EAIA,iCAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EDmJA,mCAAA;ACxIF;ADHE;EAAI,sBAAA;ACMN;ADuIE;EChKF;IDgK4C,eAAA;ECnI1C;AACF;;AAfA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,uBAAA;EACA,kDAAA;AAkBF;AAhBE;EACE,eAAA;EACA,gBAAA;EACA,cDrBK;ACuCT;AAfE;EDUA,kDA3BW;EA4BX,gBAAA;EACA,eCXqB;EDYrB,iBAAA;EACA,sBAAA;EACA,cAxCK;EC2BH,SAAA;AAsBJ;;AAlBA;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,4CAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AAqBF;;AAlBA;EACE,mBAAA;EACA,qCD7CK;ACkEP;;AAlBA;EDXE,kDA3BW;EA4BX,gBAAA;EACA,eCUmB;EDTnB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECgDL,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AA0BF;;AAvBA;EACE,yDD9CU;EC+CV,eAAA;EACA,cDvDO;ACiFT;AAxBE;EACE,wBAAA;AA0BJ;;AAtBA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAyBF;AAvBE;EACE,aAAA;AAyBJ;;AArBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AAwBF;AAtBE;EACE,WAAA;AAwBJ;;AApBA;EDyDE,gBAAA;EACA,qBAAA;EACA,qDAAA;ECzDA,cAAA;EACA,aAAA;EACA,sBAAA;AAyBF;ADgCE;EAAuB,UAAA;AC7BzB;AD8BE;EAA6B,oCAAA;EAAsC,kBAAA;AC1BrE;;AA7BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,cDpGO;ECqGP,gBAAA;EACA,SAAA;EACA,+CAAA;EACA,kCAAA;EACA,kFAAA;AAgCF;AA9BE;EACE,eAAA;AAgCJ;AA9BI;EACE,qCDpHO;ECqHP,cDjHC;ECkHD,mCAAA;AAgCN;AA5BE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA8BJ;AA3BE;EACE,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AA6BJ;;AAzBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cDzIO;ACqKT;;AAzBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AA4BF;;AAxBA;EDvFE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC2GF;ADpHE;EAAyB,qCAAA;EAAuC,8BAAA;ACwHlE;ADvHE;EAA0B,0BAAA;AC0H5B;ADzHE;EAAa,YAAA;EAAc,mBAAA;AC6H7B;AD5HE;EAAkB,oCAAA;EAAsC,mBAAA;ACgI1D;ADxHE;EAAyB,6BAAA;EAA+B,+BAAA;AC4H1D;AA7DE;EACE,cD3JG;EC4JH,qCAAA;EACA,sCD9JU;AC6Nd;AA7DI;EACE,cDhKC;ECiKD,qCAAA;EACA,8BAAA;AA+DN;AA3DE;EDvEA,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACqIF;ADnIE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACuOT;AAhEE;EACE,cDzKK;EC0KL,qCAAA;EACA,uCD/KG;ACiPP;;AA5DA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EDjCA,mCAAA;ACiGF;AD/FE;ECwBF;IDxB4C,eAAA;ECmG1C;AACF;;AAjEA;EDlLE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;ECwKA,oBAAA;EACA,sBAAA;EACA,kBAAA;AA0EF;AD9PE;EAAI,sBAAA;ACiQN;AA3EE;EDjKA,kDA3BW;EA4BX,gBAAA;EACA,eCgKqB;ED/JrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECsMH,mBAAA;AAkFJ;AA/EE;ED7JA,eAAA;EACA,gBAAA;EACA,cA7CO;EC0ML,eAAA;EACA,cD5MG;EC6MH,mBAAA;AAmFJ;AAhFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAkFJ;AA/EE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAiFJ;;AA7EA;EDhKE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ECmJA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AA+FF;ADnPE;EAAyB,qCAAA;EAAuC,8BAAA;ACuPlE;ADtPE;EAA0B,0BAAA;ACyP5B;ADxPE;EAAa,YAAA;EAAc,mBAAA;AC4P7B;AD3PE;EAAkB,oCAAA;EAAsC,mBAAA;AC+P1D;;AA3GA;EDnHE,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC6GA,WAAA;EACA,YAAA;EACA,kBAAA;AAsHF;ADnOE;EAAU,aAAA;EAAe,8BAAA;ACuO3B;ADtOE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC6O1G","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","// Trade window. Centred modal, ink panel look shared with the escape menu and\r\n// the housing drawer (see theme/_ink.scss).\r\n@use '../../theme/ink' as ink;\r\n\r\n.trade-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(2, 3, 8, 0.6);\r\n  pointer-events: none;\r\n  font-family: ink.$font-text;\r\n}\r\n\r\n.trade-shell {\r\n  @include ink.panel;\r\n  pointer-events: auto;\r\n  position: relative;\r\n  // Grows with the viewport up to 4K-ish sizes (the CEF surface renders 1:1\r\n  // with the physical screen, no DPI scaling). Width is capped so ultrawide\r\n  // monitors do not get a stretched box.\r\n  width: clamp(900px, 82vw, 1700px);\r\n  height: clamp(560px, 65vh, 1150px);\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  @include ink.enter;\r\n}\r\n\r\n.trade-header {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 4px;\r\n  padding: 18px 24px 14px;\r\n  border-bottom: 1px solid ink.$line;\r\n\r\n  &__brand {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: ink.$text-2;\r\n  }\r\n\r\n  &__title {\r\n    @include ink.title(26px);\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.trade-body {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1px 200px 1px 1fr;\r\n  gap: 20px;\r\n  padding: 16px 24px 20px;\r\n  overflow: hidden;\r\n}\r\n\r\n.trade-divider {\r\n  align-self: stretch;\r\n  background: ink.$line;\r\n}\r\n\r\n.trade-heading {\r\n  @include ink.title(17px);\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.trade-lock-tag {\r\n  font-family: ink.$font-text;\r\n  font-size: 13px;\r\n  color: ink.$text-3;\r\n\r\n  &--accent {\r\n    color: var(--gold-light);\r\n  }\r\n}\r\n\r\n.trade-pane {\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  &--locked {\r\n    opacity: 0.85;\r\n  }\r\n}\r\n\r\n.trade-pane-group {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  min-height: 0;\r\n\r\n  .trade-pane {\r\n    flex: 1 1 0;\r\n  }\r\n}\r\n\r\n.trade-list {\r\n  @include ink.scroll;\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.trade-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 9px 10px 9px 12px;\r\n  font-size: 15px;\r\n  color: ink.$text-2;\r\n  background: none;\r\n  border: 0;\r\n  border-top: 1px solid ink.$line;\r\n  border-left: 2px solid transparent;\r\n  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;\r\n\r\n  &--clickable {\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background: ink.$ink-raised;\r\n      color: ink.$text;\r\n      border-left-color: var(--gold-main);\r\n    }\r\n  }\r\n\r\n  &__name {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  &__count {\r\n    flex: none;\r\n    margin-left: 10px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: var(--gold-light);\r\n  }\r\n}\r\n\r\n.trade-empty {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  color: ink.$text-3;\r\n}\r\n\r\n.trade-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n// Neutral by default; the first non-ghost button of a view is the primary.\r\n.trade-choose-btn {\r\n  @include ink.button;\r\n  @include ink.button-primary;\r\n\r\n  &--ghost {\r\n    color: ink.$text;\r\n    background: rgba(255, 255, 255, 0.07);\r\n    border-color: ink.$line-strong;\r\n\r\n    &:hover:not(:disabled) {\r\n      color: ink.$text;\r\n      background: rgba(255, 255, 255, 0.12);\r\n      border-color: var(--gold-dark);\r\n    }\r\n  }\r\n\r\n  &--danger {\r\n    @include ink.button-danger;\r\n  }\r\n\r\n  &:disabled {\r\n    color: ink.$text-3;\r\n    background: rgba(255, 255, 255, 0.05);\r\n    border-color: ink.$line;\r\n  }\r\n}\r\n\r\n// Confirmation-style overlays (invite prompt, count prompt)\r\n\r\n.trade-confirm-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 3;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(2, 3, 5, 0.72);\r\n  @include ink.enter;\r\n}\r\n\r\n.trade-confirm {\r\n  @include ink.panel;\r\n  pointer-events: auto;\r\n  width: min(460px, 86%);\r\n  padding: 22px 24px;\r\n\r\n  &__title {\r\n    @include ink.title(20px);\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  &__text {\r\n    @include ink.lead;\r\n    font-size: 15px;\r\n    color: ink.$text;\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  &__row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  &__actions {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n  }\r\n}\r\n\r\n.trade-step-btn {\r\n  @include ink.button;\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 0;\r\n  font-size: 18px;\r\n}\r\n\r\n.trade-count-input {\r\n  @include ink.field;\r\n  width: 72px;\r\n  height: 36px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
